import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import AppShell from "./components/layout/AppShell";
import DashboardPage from "./pages/dashboard/DashboardPage";
import ForgotPasswordPage from "./pages/auth/ForgotPasswordPage";
import LoginPage from "./pages/auth/LoginPage";
import ResetPasswordPage from "./pages/auth/ResetPasswordPage";
import UsersPage from "./pages/users/UsersPage";
import PartnersPage from "./pages/partners/PartnersPage";
import ArtistCategoriesPage from "./pages/content/ArtistCategoriesPage";
import ArtistsPage from "./pages/content/ArtistsPage";
import TextPagesPage from "./pages/content/TextPagesPage";
import SlideshowsPage from "./pages/content/SlideshowsPage";
import SeoPage from "./pages/content/SeoPage";
import ArticlesPage from "./pages/content/ArticlesPage";
import OrganizersPage from "./pages/event-content/OrganizersPage";
import HallsPage from "./pages/event-content/HallsPage";
import CategoriesPage from "./pages/event-content/CategoriesPage";
import PriceTypesPage from "./pages/event-content/PriceTypesPage";
import GeoPage from "./pages/geo/GeoPage";
import ToursPage from "./pages/event-content/ToursPage";
import PromoCodesPage from "./pages/event-content/PromoCodesPage";
import DiscountsPage from "./pages/event-content/DiscountsPage";
import CouponsPage from "./pages/event-content/CouponsPage";
import HallSchemesPage from "./pages/hall-schemes/HallSchemesPage";
import OrdersPage from "./pages/orders/OrdersPage";
import SubscriptionsPage from "./pages/subscriptions/SubscriptionsPage";
import SettingsPage from "./pages/settings/SettingsPage";
import ApiDistributorsPage from "./pages/api-distributors/ApiDistributorsPage";
import GeneralStatisticsPage from "./pages/statistics/GeneralStatisticsPage";
import TourStatisticsPage from "./pages/statistics/TourStatisticsPage";
import DistributorStatisticsPage from "./pages/statistics/DistributorStatisticsPage";
import ApiOrdersStatisticsPage from "./pages/statistics/ApiOrdersStatisticsPage";
import { getAccessToken } from "./services/storage/token.storage";

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const token = getAccessToken();

    if (!token) {
        return <Navigate to="/login" replace />;
    }

    return <>{children}</>;
};

const App: React.FC = () => {
    return (
        <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />

            <Route
                path="/"
                element={
                    <ProtectedRoute>
                        <AppShell />
                    </ProtectedRoute>
                }
            >
                <Route index element={<DashboardPage />} />
                <Route path="users" element={<UsersPage />} />
                <Route path="partners" element={<PartnersPage />} />

                <Route path="content/text-pages" element={<TextPagesPage />} />
                <Route path="content/slideshows" element={<SlideshowsPage />} />
                <Route path="content/seo" element={<SeoPage />} />
                <Route path="content/articles" element={<ArticlesPage />} />
                <Route path="content/settings" element={<SettingsPage />} />

                <Route path="directory/categories" element={<CategoriesPage />} />
                <Route path="directory/price-types" element={<PriceTypesPage />} />
                <Route path="directory/geo" element={<GeoPage />} />
                <Route path="directory/artist-categories" element={<ArtistCategoriesPage />} />
                <Route path="directory/artists" element={<ArtistsPage />} />
                <Route path="directory/organizers" element={<OrganizersPage />} />
                <Route path="directory/halls" element={<HallsPage />} />

                <Route path="tours" element={<ToursPage />} />
                <Route path="promo-codes" element={<PromoCodesPage />} />
                <Route path="discounts" element={<DiscountsPage />} />
                <Route path="coupons" element={<CouponsPage />} />

                <Route path="hall-schemes" element={<HallSchemesPage />} />
                <Route path="orders" element={<OrdersPage />} />
                <Route path="subscriptions" element={<SubscriptionsPage />} />
                <Route path="api-distributors" element={<ApiDistributorsPage />} />

                <Route path="statistics/general" element={<GeneralStatisticsPage />} />
                <Route path="statistics" element={<TourStatisticsPage />} />
                <Route path="statistics/distributors" element={<DistributorStatisticsPage />} />
                <Route path="statistics/api-orders" element={<ApiOrdersStatisticsPage />} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    );
};

export default App;
